import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getVisualBuilderBasePayload } from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { selectedVariations } from "@src/store/slices/variations";
import { mpVisualBuilderOpened } from "@src/utils/mixpanel";
import { getAiModStats } from "@src/store/slices/experienceBuilder/common/selectors/getAiModStats";

export const trackBuilderOpened = createAsyncThunk<void, void>(
  "experienceBuilder/tracking/builderOpened",
  (_, { getState }) => {
    const basePayload = getVisualBuilderBasePayload(getState());
    if (basePayload) {
      const device = experienceBuilderSlice.selectors.getDevice(getState());
      const variations = selectedVariations(getState());

      mpVisualBuilderOpened({
        ...basePayload,
        builder_mode: device,
        test_group_count: variations.length,
      });
    }
  }
);
